import React, { useState } from "react";

const UNGROUPED = "__ungrouped__";

// Reusable list renderer: groups entries into collapsible sections by
// getGroupValue(entry), or renders a flat list if getGroupValue is omitted.
// Group labels/order come from groupField.option, or groupField.menuOption(rootData)
// when present (falls back to .option if that throws, e.g. rootData not loaded yet).
const GroupedCollapsibleList = ({
  entries = [],
  getGroupValue,
  groupField,
  rootData,
  renderItem,
  ungroupedLabel = "Unassigned",
}) => {
  const [expandedGroups, setExpandedGroups] = useState({});

  if (!getGroupValue) return entries.map((entry) => renderItem(entry));

  let groupOptions = groupField?.option || [];
  if (groupField?.menuOption && rootData) {
    try {
      groupOptions = groupField.menuOption(rootData) || groupOptions;
    } catch (e) {
      // menuOption reads nested root data that may not be loaded yet
    }
  }

  const orderedKeys = [...groupOptions.map((option) => option.id), UNGROUPED];
  const groups = orderedKeys.reduce((acc, key) => {
    acc[key] = [];
    return acc;
  }, {});

  entries.forEach((entry) => {
    const value = getGroupValue(entry);
    const key = value && groups[value] ? value : UNGROUPED;
    groups[key].push(entry);
  });

  return orderedKeys
    .filter((key) => groups[key].length > 0)
    .map((key) => {
      const label =
        key === UNGROUPED
          ? ungroupedLabel
          : groupOptions.find((option) => option.id === key)?.name || key;
      const isOpen = expandedGroups[key] ?? false;

      return (
        <div
          key={key}
          style={{
            border: "1px solid lightgray",
            marginBottom: "10px",
          }}
        >
          <div
            onClick={() =>
              setExpandedGroups((prev) => ({ ...prev, [key]: !isOpen }))
            }
            style={{
              cursor: "pointer",
              padding: "8px 12px",
              background: "#eef1f5",
              fontWeight: 600,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span>
              {label}
            </span>
            <span>{isOpen ? "▲" : "▼"}</span>
          </div>
          {isOpen && (
            <div style={{ padding: "8px" }}>
              {groups[key].map((entry) => renderItem(entry))}
            </div>
          )}
        </div>
      );
    });
};

export default GroupedCollapsibleList;
